export default __webpack_public_path__ + "static/media/koala2.734a02cb.png";